const IMAGE = 'IMAGE';
const ICON = 'ICON';
export const IMAGE_TYPES = {
  IMAGE,
  ICON
};